__turbopack_context__.v({
  "tagsList": "_vSBuG_tagsList",
});
